import { createSlice } from "@reduxjs/toolkit";
import { getUsersListThunk } from "../thunks/userThunk";

const initialState = {
    users: null,
};

const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getUsersListThunk.fulfilled, (state, action) => {
            state.users = action?.payload?.data;
        })
    }
});

// export const { logout } = userSlice.actions;
export default userSlice.reducer;
